import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TopicSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 mb-8">
          <span className="w-1 h-6 rounded-full bg-accent-500"></span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">动漫专题合集</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {topics.map((topic) => (
            <Link
              key={topic.id}
              to="/anime"
              className="group relative rounded-lg overflow-hidden h-48 md:h-56 border border-background-200 wf-fade-up"
            >
              <img
                src={topic.cover}
                alt={`${topic.title} 专题封面`}
                title={`${topic.title} - 火狼动漫网专题`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-transparent"></div>
              <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
                <span className="inline-flex items-center gap-1 self-start px-2 py-0.5 rounded-md bg-accent-500 text-primary-950 text-xs font-bold mb-2">
                  {topic.count} 部作品
                </span>
                <h3 className="text-lg md:text-xl font-bold text-background-50 mb-1">{topic.title}</h3>
                <p className="text-xs md:text-sm text-background-200 leading-relaxed wf-line-clamp-2">
                  {topic.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}